import { Loader } from '@comall-backend-builder/core/lib/loaders';

import { InfoLoader } from './info-loader';
import { BlackListLoader } from './black-list-loader';
import { ShippingOrder } from './shippingOrder-loader';
import { DeliveryOrder } from './deliverOrder-loader';
import { LoginLoader, PrivilegesLoader } from './login-loader';
import { DesignTypeLoader, DesignTypeFilterLoader } from './design-type-loader';
import {
    CategoryBaseInfoLoader,
    CategoryFilterAttrLoader,
    CategoryUnionProductLoader,
    CategoryUnionProductTypeLoader,
    CategoryTreeLoader,
    CategoryBaseInfoThreeLoader,
} from './category-loader';
import { TemplateLoader } from './template-loader';
import { ProductCategoryCodeSelect } from './product-category-code-select';
import { LiveProductLoader } from './live-product';
import { LiveRoomListLoader, LiveRoomDetailLoader, LiveRoomProductsLoader } from './live-room';
import { LiveListLoader } from './live-list';
import {
    SaleOrderPayingListSknsLoader,
    SaleOrderPayingListLoader,
    SaleOrderChangePriceDetailLoader,
    SaleOrderChangePriceDetailSknLoader,
} from './order-change-price';
import { ProductGoodsSalesTagSelect } from './product-goods-salesTag-select';
import { reportFormsListImportLoader, reportFormsListExportLoader } from './report-forms';
import { ProductFindPostLoader } from './product-find-post';
import { FindSendOutPageLoader } from './shipping-order';
import { FindDeliveryPageLoader } from './delivery-order';

const myLoaders = new Map<string, Loader>();

myLoaders.set('/info', InfoLoader);
myLoaders.set('/black-list', BlackListLoader);
myLoaders.set('/shippingOrder', ShippingOrder);
myLoaders.set('/deliveryOrder', DeliveryOrder);
myLoaders.set('/login', LoginLoader);
myLoaders.set('/privileges', PrivilegesLoader);
myLoaders.set('/design-type', DesignTypeLoader);
myLoaders.set('/design-type-filter', DesignTypeFilterLoader);
myLoaders.set('/category-base-info', CategoryBaseInfoLoader);
myLoaders.set('/category-base-three-info', CategoryBaseInfoThreeLoader);
myLoaders.set('/category-union-product', CategoryUnionProductLoader);
myLoaders.set('/category-union-product-type', CategoryUnionProductTypeLoader);
myLoaders.set('/category-filter-attr', CategoryFilterAttrLoader);
myLoaders.set('/category-tree', CategoryTreeLoader);
myLoaders.set('/template', TemplateLoader);
myLoaders.set('/product-category-code-select', ProductCategoryCodeSelect);
myLoaders.set('/live-product', LiveProductLoader);
myLoaders.set('/live-room-list', LiveRoomListLoader);
myLoaders.set('/live-room-detail', LiveRoomDetailLoader);
myLoaders.set('/live-room-products', LiveRoomProductsLoader);
myLoaders.set('/order-paying-list', SaleOrderPayingListLoader);
myLoaders.set('/order-paying-list-skn', SaleOrderPayingListSknsLoader);
myLoaders.set('/order-change-price-detail', SaleOrderChangePriceDetailLoader);
myLoaders.set('/order-change-price-detail-skn', SaleOrderChangePriceDetailSknLoader);
myLoaders.set('/product-goods-salesTag-select', ProductGoodsSalesTagSelect);
myLoaders.set('/products-find-post', ProductFindPostLoader);
myLoaders.set('/find-send-out-page', FindSendOutPageLoader);
myLoaders.set('/find-delivery-page', FindDeliveryPageLoader);

// 直播列表loader
myLoaders.set('/live-list', LiveListLoader);

// 批量导入列表
myLoaders.set('/uploadManage', reportFormsListImportLoader);

// 批量导出列表
myLoaders.set('/exportQueQue', reportFormsListExportLoader);

export default myLoaders;
